import { ReactNode } from 'react';

import { useResponsive } from '@hooks';

// used in the login and update credentials screens
export const CUSTOM_LAPTOP_WIDTH = 1024;

export interface BreakpointsRenderProps {
	mobile?: ReactNode;
	laptop?: ReactNode;
	customLaptopWidth?: number;
}

export const BreakpointsRender = ({ mobile, laptop, customLaptopWidth }: BreakpointsRenderProps) => {
	const { platform, windowWidth } = useResponsive();

	const shouldRenderLaptop = customLaptopWidth ? customLaptopWidth < windowWidth : platform === 'laptop';

	if (shouldRenderLaptop) {
		return laptop;
	}

	return mobile;
};
